/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/MapDataReport', 'model/CorporateStructureFilter'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/MapDataReport'), require('../model/CorporateStructureFilter'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.MapRegionApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.MapDataReport, root.ForStractionServiceApi.CorporateStructureFilter);
  }
}(this, function(ApiClient, MapDataReport, CorporateStructureFilter) {
  'use strict';

  /**
   * MapRegion service.
   * @module api/MapRegionApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new MapRegionApi. 
   * @alias module:api/MapRegionApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the mapRegionLoadDataReportPut operation.
     * @callback module:api/MapRegionApi~mapRegionLoadDataReportPutCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MapDataReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadDataReport
     * @param {String} _4SAPIAppID 
     * @param {module:model/CorporateStructureFilter} body 
     * @param {Date} startDate 
     * @param {Date} endDate 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.maxInvoicesCount  (default to 0)
     * @param {module:api/MapRegionApi~mapRegionLoadDataReportPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MapDataReport}
     */
    this.mapRegionLoadDataReportPut = function(_4SAPIAppID, body, startDate, endDate, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling mapRegionLoadDataReportPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling mapRegionLoadDataReportPut";
      }

      // verify the required parameter 'startDate' is set
      if (startDate == undefined || startDate == null) {
        throw "Missing the required parameter 'startDate' when calling mapRegionLoadDataReportPut";
      }

      // verify the required parameter 'endDate' is set
      if (endDate == undefined || endDate == null) {
        throw "Missing the required parameter 'endDate' when calling mapRegionLoadDataReportPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'startDate': startDate,
        'endDate': endDate,
        'maxInvoicesCount': opts['maxInvoicesCount']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = MapDataReport;

      return this.apiClient.callApi(
        '/MapRegion/loadDataReport', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
